<template>
  <div class="container">
    <!--<Row>
      <Col span="7" offset="0"><input type="text" class="shape"><button class="btn" value="">确定</button></input></Col>
    </Row>-->
    <Row>
      <Col span="24" class="bgwhite darkshadow">
        <Row style="padding:20px 20px 0px 20px;border-bottom:1px solid #e8eaec;">
          <Col>
            <!-- <Col span="3" offset="1" style="font-size: 20px;cursor: pointer">
              <div class="list-control-order-item listDiv" @click="borderOrange(1)" :class="{bdOr:borderOrangeNum==1}">
                    默认排序
              </div>
            </Col>
            <Col span="3" offset="1" style="font-size: 20px;cursor: pointer">
              <div class="list-control-order-item listDiv" @click="handleInfotime();borderOrange(2)" :class="{bdOr:borderOrangeNum==2}">
                    最新发布
                    <span v-if="time === 'time-asc'">↑</span>
                    <span v-if="time === 'time-desc'">↓</span>
              </div>
            </Col>
            <Col span="3" offset="1" style="font-size: 20px;cursor: pointer">
              <div class="list-control-order-item listDiv" @click="handleInfoprice();borderOrange(3)" :class="{bdOr:borderOrangeNum==3}">
                    价格
                    <span v-if="price === 'price-asc'">↑</span>
                    <span v-if="price === 'price-desc'">↓</span>
              </div>
            </Col> -->
            <Col span="12" offset="12" style="font-size: 14px;text-align:right;">
              为您找到{{info.length}}个好项目
            </Col>
          </Col>
        </Row>
        <br>
        <iproject v-for="(item,index) in info" :item="item" :key="index"></iproject>
          <Col style="height:600px;" v-if="info.length===0"><span style="font-size:15px;" >暂无数据</span></Col>
        <br>
       <Page :total="total" :current="pageNum" :page-size="10"  show-sizer show-total 
 @on-change="handlePage" @on-page-size-change='handlePageSize'></Page>                                                               
        <br>
      </Col>
    </Row>
  </div>
</template>

<script>
  import iproject from './components/index'
  export default {
    components:{
      iproject
    },
    data(){
      return{
        info:[],
        total:null,
        price:'price-asc',
        time:'time-asc',
        pageNum:1,
        pageSize:[5,10,15,20],
        borderOrangeNum:2,
        title:'',
        status:'',
        limit:'',
        pageNum:1
     /*    info:[
     {
            id:0,
            pic:"../../../static/5.jpg",
            name:' 大华星氟化学有限公司100%股权及501.318148万元债权',
            detail:'岭南市产权交易接受铁岭市国有资产经营有限责任公司的委托，对其拥有的车辆进行公开出售，为体现公开、公平、公正的原则，本次车辆的出售采取拍卖方式' +
              '，价高者得，竞买人确认交易费用，岭市产权交易岭南市产权交易接受司的委托，' +
              '对其拥有的车辆进行公开出售，为体现公开、公平、公正的原则，本次车辆的出售采取拍卖方辆进行公开出售，为体现公开、公平、公正的原则，本次车辆的出售采取拍卖方辆进行公开出售，为体现公开、公平、公正的原则，本次车辆的出售采取拍卖方式，价高者得，竞买人确认交易费用，岭市产权交易',
            date:'2017-08-14',
            price:'￥2000万',
            state:'成交历史',
            locate:'北京'

          }
        ] */

      }
    },
    mounted(){
      this.investmentSearchList()
    },
    methods:{
      investmentSearchList:function(){
          protocol.param_investmentList.param.title = this.title;
          protocol.param_investmentList.param.status=this.status;
          protocol.param_investmentList.param.limit=this.limit;
          protocol.param_investmentList.param.page=this.pageNum;
          http.gets(protocol.param_investmentList,protocol.param_investmentList.param).then(response => {
          let { msg,code, page} = response.data;
          if (code ===0) {
           this.total = page.total;
           //this.pageNum = page;
           for( let value of page.rows){
                let obj={};
                obj.investmentId = value.investmentId;
                obj.investmentTitle  = value.investmentTitle;
                obj.investmentStart = value.investmentStart;
                obj.investmentEnd  = value.investmentEnd;
                obj.investmentContent  = value.investmentContent;
                obj.linkman = value.linkman;
                obj.mobile = value.mobile;
                obj.email = value.email;
                obj.status = value.status;
                obj.auditLevel = value.auditLevel;
                obj.auditStatus = value.auditStatus;
                obj.space  = value.space;
                obj.spaceName = value.spaceName;
                obj.createTime  = value.createTime;
                obj.createUserName= value.createUserName;
                obj.updTime = value.updTime;
                obj.updUserName = value.updUserName;
                this.info.push(obj);
            }
        }else{
          this.info = [];
        }
      });
         

      },
      query :function (index) {
        this.changebgor = index;

      },
      query1 :function (index) {
        this.changebgor1 = index;

      },
      query2 :function (index) {
        this.changebgor2 = index;

      },
      query3:function (index) {
        this.changebgor3 = index;

      },
      handleInfoprice :function ()

      {
        if (this.price ==='price-asc') {
          this.price = 'price-desc';
        } else {
          this.price = 'price-asc';
        }
      },
      handleInfotime :function ()

      {
        if (this.time ==='time-asc') {
          this.time = 'time-desc';
        } else {
          this.time = 'time-asc';
        }
      },
      borderOrange:function(val){
        console.log(val)
        if (val == 3) {
          this.borderOrangeNum=3
        } else if (val ==2) {
          this.borderOrangeNum=2
        } else {
          this.borderOrangeNum=1
        }
      },
      handlePageSize(val){
        this.pageSize = val;
 
      },
      handlePage(val){
        this.pageNum = val;
        this.investmentSearchList();
      }

    }
  }
</script>

<style scoped>
  li{
    float: left;
    margin-right: 20px;
    cursor: pointer;
    font-size: 15px;
    padding: 5px;
  }
  .bgor{
    background: orange;
    border-radius: 3px;
  }
  .bdOr{
    border-bottom: 2px solid orange;
  }
  .listDiv{
    height: 45px;
  }
  .shape{
    border: 2px solid orange;
    outline: none;
    height:30px;
    width: 180px;
  }
.btn{
  height: 30px;
  width:50px;
   
   border: 2px solid orange;
   background: orange;
   color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/investment/index.vue